function _interactive() {
  const grids = document.querySelectorAll('[data-type="feature-grid-filter"]')

  const switchItemFocus = (item: HTMLElement, status: 'on' | 'off') => {
    const cta = item.querySelector('a.link')

    if (status === 'on') {
      cta?.setAttribute('tabindex', '0')
    } else {
      cta?.setAttribute('tabindex', '-1')
    }
  }

  grids.forEach((grid) => {
    const cards = grid.querySelectorAll(
      '.featureGridFilter__newsCard'
    ) as NodeListOf<HTMLElement>

    cards.forEach((card) => {
      const image = card.querySelector('a:has(img)')
      const title = card.querySelector('a:has(.newsCard__title)')
      const cta = card.querySelector('a.link')

      image?.setAttribute('tabindex', '-1')
      title?.setAttribute('tabindex', '-1')
      cta?.setAttribute('tabindex', '-1')
    })

    // Sort cards by their numerical order in the class name
    const sortedCards = Array.from(cards).sort((a, b) => {
      const aMatch = a.className.match(/featureGridFilter__newsCard--(\d+)/)
      const bMatch = b.className.match(/featureGridFilter__newsCard--(\d+)/)

      // If no match found for either element, keep original order
      if (!aMatch) return !bMatch ? 0 : -1
      if (!bMatch) return 1

      // Compare numeric values
      return parseInt(aMatch[1], 10) - parseInt(bMatch[1], 10)
    })

    // Reappend the sorted cards to maintain the new order
    sortedCards.forEach((card) => {
      card.parentNode?.appendChild(card)
    }) as unknown as NodeListOf<HTMLElement>

    // Set first card's link to be tabbable if it exists
    if (sortedCards.length > 0) {
      sortedCards[0].querySelector('a.link')?.setAttribute('tabindex', '0')
    }

    // Add keyboard navigation to the cards
    // Add keyboard event listeners to each item
    sortedCards.forEach((item, index) => {
      item.addEventListener('keydown', (e) => {
        let nextIndex

        switch (e.key) {
          case 'Tab':
            if (!e.shiftKey) {
              // If we're at the last item, let the browser handle normal tab behavior
              if (index === sortedCards.length - 1) {
                return
              }
              nextIndex = index + 1
              break
            } else {
              // If we're at the first item, let the browser handle normal shift+tab behavior
              if (index === 0) {
                return
              }
              nextIndex = index - 1
              break
            }
          default:
            return
        }

        // Update tabindex for all items
        sortedCards.forEach((item) => switchItemFocus(item, 'off'))
        switchItemFocus(sortedCards[nextIndex], 'on')

        const cta = sortedCards[nextIndex].querySelector(
          'a.link'
        ) as HTMLElement
        cta?.focus()

        e.preventDefault()
      })
    })
  })

  const mobileGrids = document.querySelectorAll(
    '[data-type="feature-grid-mobile"]'
  )

  mobileGrids.forEach((grid) => {
    const cards = grid.querySelectorAll('.newsCard') as NodeListOf<HTMLElement>

    cards.forEach((card) => {
      const image = card.querySelector('a:has(img)')
      const title = card.querySelector('a:has(.newsCard__title)')

      image?.setAttribute('tabindex', '-1')
      title?.setAttribute('tabindex', '-1')
    })
  })

  const attachMobileFilterTextClicks = () => {
    const mobileContainers = document.querySelectorAll(
      '.featureGridFilter__filter-container--mobile'
    ) as NodeListOf<HTMLElement>

    mobileContainers.forEach((container) => {
      const enhancedContainer = container as HTMLElement & {
        __fgfTextClickHandler?: EventListener
      }

      if (enhancedContainer.__fgfTextClickHandler) {
        return
      }

      const handleClick: EventListener = (event) => {
        const target = event.target as HTMLElement | null
        if (!target) return

        const textElement = target.closest(
          '.checkbox-label-text'
        ) as HTMLElement | null
        if (!textElement) return

        const parentItem = textElement.closest('.checkbox-main-item')
        const hasExpandButton =
          parentItem?.querySelector('.checkbox-expand-button')

        if (hasExpandButton) {
          return
        }

        const label = textElement.closest('label')
        const input = label?.querySelector<HTMLInputElement>(
          'input[type="radio"]'
        )

        if (input) {
          event.stopPropagation()
          input.click()
        }
      }

      container.addEventListener('click', handleClick, true)
      enhancedContainer.__fgfTextClickHandler = handleClick
    })
  }

  attachMobileFilterTextClicks()
}

export default _interactive
